var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket active"},[_c('div',[_c('h3',[_vm._v("We are currently experiencing high demand, this page will automatically refresh in "+_vm._s(_vm.secondsLeft)+" seconds.")]),_vm._v(" "),_c('p',[_vm._v("Please be patient and wait for the countdown to complete\n        and the page to refresh. When a place becomes available you will\n        have the opportunity to purchase tickets if they are still available.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Features/Event/Components/throttle.vue?vue&type=template&id=45695243&